import { FC } from 'react';
import { WbBadge } from '../WbBadge';

type WbStatusBadgeProps = {
  ok: boolean;
};

export const WbStatusBadge: FC<WbStatusBadgeProps> = ({ ok }) => {
  return <WbBadge color={ok ? 'success' : 'error'}>{ok ? 'OK' : 'KO'}</WbBadge>;
};
